import { Grid, TableCell, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { RowType } from '../../../pages/FinancialForensicsPage/FinancialForensics.types';
import { Column, TableRows } from './TableRow';
import React from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

type TableSectionProps = {
  label: string;
  addButton: React.ReactNode;
  columns: Column[];
  data: any[];
  rowType: RowType;
  emptyState: React.ReactNode;
};

const useStyles = makeStyles()({
  tableSection: {
    backgroundColor: patientAccessTheme.palette.grey[400],
  },
  tableSectionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cell: {
    padding: '8px 18px 8px 20px',
    borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
    borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
    '&:last-child': {
      borderRight: 'none',
    },
  },
});

export const TableSection: React.FC<TableSectionProps> = ({
  label,
  addButton,
  columns,
  data,
  rowType,
  emptyState,
}) => {
  const { classes } = useStyles();

  return (
    <>
      <TableRow>
        <TableCell
          className={`${classes.cell} ${classes.tableSection}`}
          colSpan={columns.length}
        >
          <Grid className={classes.tableSectionContainer}>
            <Typography
              fontSize="14px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {label}
            </Typography>
            {addButton}
          </Grid>
        </TableCell>
      </TableRow>
      <TableRows
        data={data}
        columns={columns}
        rowType={rowType}
        emptyState={emptyState}
      />
    </>
  );
};
